var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 77,
    viewBox: "0 0 168 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.5 1C164.366 1 167.5 4.134 167.5 8C167.5 11.866 164.366 15 160.5 15H120.5C124.366 15 127.5 18.134 127.5 22C127.5 25.866 124.366 29 120.5 29H142.5C146.366 29 149.5 32.134 149.5 36C149.5 39.866 146.366 43 142.5 43H132.326C127.452 43 123.5 46.134 123.5 50C123.5 52.5773 125.5 54.9107 129.5 57C133.366 57 136.5 60.134 136.5 64C136.5 67.866 133.366 71 129.5 71H46.5C42.634 71 39.5 67.866 39.5 64C39.5 60.134 42.634 57 46.5 57H7.5C3.634 57 0.5 53.866 0.5 50C0.5 46.134 3.634 43 7.5 43H47.5C51.366 43 54.5 39.866 54.5 36C54.5 32.134 51.366 29 47.5 29H22.5C18.634 29 15.5 25.866 15.5 22C15.5 18.134 18.634 15 22.5 15H62.5C58.634 15 55.5 11.866 55.5 8C55.5 4.134 58.634 1 62.5 1H160.5ZM160.5 29C164.366 29 167.5 32.134 167.5 36C167.5 39.866 164.366 43 160.5 43C156.634 43 153.5 39.866 153.5 36C153.5 32.134 156.634 29 160.5 29Z",
    fill: "#FBBA3E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.667 40.1042V21.8167C117.667 16.4262 117.667 13.731 116.618 11.6721C115.695 9.86103 114.222 8.38859 112.411 7.46581C110.352 6.41675 107.657 6.41675 102.267 6.41675H81.7333C76.3428 6.41675 73.6476 6.41675 71.5887 7.46581C69.7776 8.38859 68.3052 9.86103 67.3824 11.6721C66.3333 13.731 66.3333 16.4262 66.3333 21.8167V55.1834C66.3333 60.5739 66.3333 63.2692 67.3824 65.3281C68.3052 67.1391 69.7776 68.6116 71.5887 69.5344C73.6476 70.5834 76.3428 70.5834 81.7333 70.5834H92M98.4166 35.2917H79.1666M85.5833 48.1251H79.1666M104.833 22.4584H79.1666M100.021 60.9584L106.437 67.3751L120.875 52.9376",
    stroke: "#FBBA3E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.95bd7ce1227cca45db7fe5cb263d837c.svg";
export { ForwardRef as ReactComponent };